import {Box, Flex, HStack, Icon, Input, Spinner, Text, Textarea, VStack} from "@chakra-ui/react";
import {IoCloseSharp} from "react-icons/io5";
import {GoDash} from "react-icons/go";
import {useEffect, useMemo, useState} from "react";
import ChatBubble from "@/components/ui/chat/ChatBubble";
import InfoBubble from "@/components/ui/chat/InfoBubble";
import ApiBubble from "@/components/ui/chat/ApiBubble";
import WhatsUpBubble from "@/components/ui/chat/WhatsUpBubble";
import TypingIndicator from "@/components/ui/chat/TypingIndicator";
import ChatInputArea from "@/components/ui/chat/ChatInputArea";
import {useChat} from "@/components/providers/ChatProvider";


const ChatFrame = ({chat, onMinimalizeClick, onCloseClick, isSending, onSendMessage, streamingState, onWhatsUpNo}) => {
    const {linkWhatsApp} = useChat();
    const [isLinking, setIsLinking] = useState(false);

    const handleOnWhatsUpYes = (phone) => linkWhatsApp(phone, chat);
    const {messages} = chat;

    useEffect(() => {
        console.log('[ChatFrame messages] 🚀 ', JSON.stringify(messages, null, 2));
    }, [messages]);

    const handleOnMinimalizeClick = () => {
        onMinimalizeClick && onMinimalizeClick();
    }

    const handleOnCloseClick = () => {
        onCloseClick && onCloseClick();
    }

    const linkToWhatsApp = async (phone, chat, onSuccess) => {
        setIsLinking(true);

        linkWhatsApp(phone, chat)
            .then(() => {
                onSuccess && onSuccess();
            })
            .finally(() => setIsLinking(false))
            .catch(err => console.error('Failed to link WhatsApp', err))
    }

    const handleOnYes = (phone, chat, onSuccess) => {
        linkToWhatsApp(phone, chat, onSuccess);
    }

    const chatContent = useMemo(() => {
        // If there are messages, render them
        if (messages && messages.length > 0) {
            return messages?.map((message, index) => {
                if (message.type === 'info') return <InfoBubble message={message} key={index} />;
                if (message.type === 'api') return <ApiBubble message={message} key={index} />;
                if (message.type !== 'image' && message.type !== 'file' && message.type !== 'document' && message.text.includes('{%WhatsApp_Start}')) return <WhatsUpBubble message={message} key={index} onYes={(phone, onSuccess) => handleOnYes(phone, chat, onSuccess)} onNo={onWhatsUpNo} />;
                return <ChatBubble message={message} key={index}/>;
            });
        }
        
        // If there are no messages, but bot is typing/streaming, render nothing to make space for indicators
        if (chat.isBotTyping || (streamingState?.chatId === chat.id)) {
            return null;
        }

        // If no messages and no bot activity, show placeholder
        return <Text color={'text.grey'}>No messages yet.</Text>
    }, [messages, chat.isBotTyping, streamingState, chat.id]);

    return (
        <VStack color={'white'} bg={'bg.chatFrame'} w={'full'} borderRadius={8} mb={4} overflow={'hidden'} gap={0}>
            <HStack color={'white'} py={2} px={4} borderTopRadius={8} w={'full'}
                    justifyContent={'space-between'} borderColor={'border.primary'} borderBottomWidth={2}>
                <HStack>
                    <Text fontSize={14} fontWeight={600}>{chat?.name}</Text>
                    <Box bg={'green.600'} w={2} h={2} borderRadius={'full'}/>
                </HStack>

                <HStack>
                    <Icon fontSize={22} color={'text.grey'} cursor={'pointer'} onClick={handleOnMinimalizeClick}>
                        <GoDash/>
                    </Icon>
                    <Icon fontSize={22} color={'text.grey'} cursor={'pointer'} onClick={handleOnCloseClick}>
                        <IoCloseSharp/>
                    </Icon>
                </HStack>
            </HStack>

            <VStack w={'full'} px={4} h={530} overflowY={'scroll'} py={8} position={'relative'}>
                {chatContent}
                {streamingState?.chatId === chat.id && (
                    <ChatBubble message={{ text: streamingState.displayText, user: 'bot', timestamp: new Date().toISOString() }} />
                )}
                {chat.isBotTyping && !streamingState && <TypingIndicator />}
            </VStack>
            <ChatInputArea onSendMessage={onSendMessage} isSending={isSending} />
        </VStack>
    )
}

export default ChatFrame;